import { useEffect, useState } from 'react'
export const useClientTheme = () => {
  const [theme, setTheme] = useState('light')
  const [mountedComponent, setMountedComponent] = useState(false)
  const setMode = (mode) => {
    window.localStorage.setItem('theme', mode)
    setTheme(mode)
  }
  const themeToggler = () => {
    theme === 'light' ? setMode('light') : setMode('light')
  }
  useEffect(() => {
    const localTheme = window.localStorage.getItem('theme')
    localTheme ? setTheme(localTheme) : setMode('light')
    setMountedComponent(true)
  }, [])
  return [theme, themeToggler, mountedComponent]
}
